import { render, staticRenderFns } from "./ResolucionesNewOrEdit_OLD.vue?vue&type=template&id=2b82bc99&scoped=true"
import script from "./ResolucionesNewOrEdit_OLD.vue?vue&type=script&lang=js"
export * from "./ResolucionesNewOrEdit_OLD.vue?vue&type=script&lang=js"
import style0 from "./ResolucionesNewOrEdit_OLD.vue?vue&type=style&index=0&id=2b82bc99&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82bc99",
  null
  
)

export default component.exports